import { useCallback, useState } from 'react';
import { GlobalSeverityType, useSnackbarHandler } from 'web-library';
import { SelectedUserInfo } from '../model';

export const useUniqueLink = () => {
  const { snackbarHandler } = useSnackbarHandler();

  const [grantAccessModalOpen, setGrantAccessModalOpen] = useState<boolean>(false);
  const [selectedUserInfo, setSelectedUserInfo] = useState<SelectedUserInfo>();
  const [sendEmailStatusList, setSentEmailStatusList] = useState<string[]>([]);

  const onGrantAccessDialogClose = () => {
    setGrantAccessModalOpen(false);
  };

  const setEditDetail = (name: string, uuid: string, index: number, useModal = true) => {
    setSelectedUserInfo({
      index,
      uuid,
      name,
    });
    if (useModal) {
      setGrantAccessModalOpen(true);
    }
  };

  const apiEmailStatusCallback = useCallback(
    (index: number, status: string, customMessage?: string) => {
      const statusList = sendEmailStatusList.slice();
      statusList[index] = status;
      setSentEmailStatusList(statusList);

      if (customMessage) {
        snackbarHandler?.setGlobalSnackbar({
          targetSeverity: status as GlobalSeverityType,
          targetData: customMessage,
        });
      }
    },
    [sendEmailStatusList, snackbarHandler]
  );

  const eligibilityStatusCallback = useCallback(
    (status: string, customMessage: string) => {
      snackbarHandler?.setGlobalSnackbar({
        targetSeverity: status as GlobalSeverityType,
        targetData: customMessage,
        targetAnchorOrigin:
          (status as GlobalSeverityType) === 'error'
            ? {
                vertical: 'bottom',
                horizontal: 'left',
              }
            : undefined,
      });
    },
    [snackbarHandler]
  );

  return {
    grantAccessModalOpen,
    selectedUserInfo,
    setSelectedUserInfo,
    sendEmailStatusList,
    setSentEmailStatusList,
    apiEmailStatusCallback,
    onGrantAccessDialogClose,
    setEditDetail,
    eligibilityStatusCallback,
  };
};
